// Offene Haushalts-Einladung (KA-29) über Registrierung hinweg merken (nur dieses Gerät).
// Eigene kleine Datei, weil AuthContext und Auth im Hauptbundle liegen.

const KEY = "cc_household_invite";

export function rememberInvite(token: string): void {
  try { sessionStorage.setItem(KEY, token); localStorage.setItem(KEY, token); } catch { /* Speicher gesperrt */ }
}

export function readPendingInvite(): string | null {
  try { return sessionStorage.getItem(KEY) ?? localStorage.getItem(KEY); } catch { return null; }
}

export function clearPendingInvite(): void {
  try { sessionStorage.removeItem(KEY); localStorage.removeItem(KEY); } catch { /* Speicher gesperrt */ }
}
